import { List, Record } from 'immutable';
import _ from 'lodash';

import { Affiliation } from 'generated/graphql';

import { properties as UserProperties, FullName } from '../user/model';
import Donation from '../donation/model';

const properties = {
  ...UserProperties,
  phone: '',
  status: '',
  fullName: {},
  facebook: {},
  state: '',
  city: '',
  country: '',
  weight: 0,
  organizationDepartment: '',
  myDeeds: [],
  createdAt: new Date(),
  mainPicture: '',
  location: '',
  donations: List(),
  tShirtSize: '',
  consent: {},
  donationCreditsAmountCurrencies: {},
  donationCreditsWallets: {},
  _fundraisersDonatedTo: 0,
  _donatedAmountCurrencies: {},
  _volunteerMinutes: 0,
  volunteerTimeOffSummary: {},
  affiliations: [],
  payrollPayGroup: {},
  organization: '',
  locale: 'en-US',
  contactEmails: [],
};

export interface ContactEmail {
  email: string;
  verified: boolean;
  verificationToken?: string;
  verificationExpires?: Date;
  verifiedAt?: Date;
}

export default class Volunteer extends Record(properties, 'Volunteer') {
  public readonly organization!: string;

  public readonly phone!: string;

  public readonly status!: string;

  public readonly fullName!: FullName;

  public readonly facebook!: object;

  public readonly state!: string;

  public readonly city!: string;

  public readonly country!: string;

  public readonly weight!: number;

  public readonly deeds!: number;

  public readonly volunteerMinutes!: number;

  public readonly organizationDepartment!: string;

  public readonly myDeeds!: string[];

  public readonly createdAt!: Date;

  public readonly mainPicture!: string;

  public readonly location!: string;

  public readonly donations!: List<Donation>;

  public readonly totalImpact!: number;

  public readonly totalImpactCurrencies!: number;

  public readonly tShirtSize!: string;

  public readonly consent!: object;

  public readonly donationCreditsAmountCurrencies!: object;

  public readonly donationCreditsWallets!: object;

  public readonly volunteerTimeOffSummary!: object;

  public readonly affiliations!: Affiliation[];

  public readonly locale!: string;

  public readonly contactEmails!: ContactEmail[];

  constructor(values: any = {}) {
    const validValues = _.pick(values, Object.keys(properties));
    super({
      ...validValues,
      type: values.type || values.__t, // eslint-disable-line
      donations:
        values.donations && List(values.donations.map((donation: any) => new Donation(donation))),
      createdAt: values.createdAt ? new Date(values.createdAt) : undefined,
    });
  }
}
